import React from 'react';
import s from './grid.module.scss';
import { getGridColumnsCount } from './grid.utils';
import type { AppBoxSkin } from '../app-box/app-box.types';

export interface GridProps {
  dataHook?: string;
  columns: 1 | 2 | 3 | 4;
  minColumns?: 1 | 2 | 3 | 4;
  rows?: number;
  itemMinWidth?: string;
  children?: React.ReactNode;
  finalColumnsCount?: (finalColumns: number) => void;
  skin?: AppBoxSkin;
}

export function Grid({
  dataHook,
  columns: maxColumns,
  minColumns = 1,
  rows: maxRows,
  itemMinWidth,
  finalColumnsCount,
  children,
  skin = 'default',
}: GridProps) {
  const gridRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (gridRef.current) {
      const columnsCount = getGridColumnsCount(gridRef.current);
      finalColumnsCount?.(columnsCount);
    }
  }, [gridRef.current]);

  return (
    <div
      ref={gridRef}
      data-hook={dataHook}
      className={`${s.gridContainer} ${skin === 'slim' ? s.slimGrid : ''}`}
      style={
        {
          '--grid-min-columns': minColumns,
          '--grid-max-columns': maxColumns,
          ...(maxRows && { '--grid-max-rows': maxRows }),
          ...(maxColumns === 1 && {
            '--grid-gap': '18px',
            '--grid-item-min-width': '250px',
          }),
          ...(skin === 'slim' && {
            '--grid-item-min-width': '237px',
            '--grid-gap': '18px',
          }),
          ...(itemMinWidth && {
            '--grid-item-min-width': itemMinWidth,
          }),
        } as React.CSSProperties
      }
    >
      {children}
    </div>
  );
}
